export { SectionHeading } from './SectionHeading';
export type { SectionHeadingProps } from './SectionHeading.types';
